/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
angular.module('comcast.common.communication').factory('UserResourceFactory', ['$resource', 'EndPointService', 'NotificationInterceptor', function ($resource, ResourceEndPointService, NotificationInterceptor) {
  'use strict';

  return $resource(ResourceEndPointService.userEndPoint + '/:id', {
    id: '@id'
  }, {
    // Reset a password
    getAll: {
      method: 'GET',
      url: ResourceEndPointService.userEndPoint,
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('users').setAction('Retrieving')
    },
    create: {
      method: 'POST',
      url: ResourceEndPointService.userEndPoint,
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('user').setAction('Creating')
    },
    getJobClassifications: {
      method: 'GET',
      url: ResourceEndPointService.jobClassificationEndPoint,
      isArray: true,
      interceptor: new NotificationInterceptor().setObject('job classifications').setAction('Retrieving')
    },
    registerLite: {
      method: 'POST',
      url: ResourceEndPointService.registerLiteEndpoint,
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('user').setAction('Registering')
    },
    updatePreference: {
      method: 'POST',
      // params: {id: '@id'},
      url: ResourceEndPointService.preferenceEndPoint,
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('preference').setAction('Updating')
    },
    exportUsers: {
      method: 'POST',
      url: ResourceEndPointService.userEndPoint + '/export/',
      isArray: true,
      interceptor: new NotificationInterceptor().setObject('users').setAction('exporting')
    }
  });
}]);